import PaymentsIcon from '@mui/icons-material/Payments';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import RECEIVABLES_TABS from '@/modules/receivables/constants/ReceivablesTable.constants';

const LendingButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const redirectToLending = () => {
    navigate(`/receivables?tab=${RECEIVABLES_TABS.COLLECT_LOCAL_PAYMENT}`);
  };
  return (
    <Grid item xs={12} lg={6}>
      <button
        type="button"
        onClick={() => redirectToLending()}
        className="fourth-step mb-3 bg-white border-solid border border-black py-5 px-8 w-full flex items-center justify-between text-[#00143a] hover:bg-[#00143a] hover:text-white transition-colors duration-200 h-full"
      >
        <div className="flex items-center">
          <div className="bg-[#ebf3fa] rounded-full w-16 h-16 flex justify-center items-center mr-3">
            <PaymentsIcon className="!h-9 !w-9 !text-[#006BF8]" />
          </div>
          <div className="text-left">
            <Typography
              variant="subtitle2"
              className="rounded-xl px-2 text-white text-xs bg-[#016bf8] inline-block"
            >
              {t('ldBtnBadge')}
            </Typography>
            <Typography
              variant="body1"
              className="!font-semibold !text-lg !my-1 !text-[inherit] !font-['Inter']"
            >
              {t('ldBtnTitle')}
            </Typography>
          </div>
        </div>
      </button>
    </Grid>
  );
};

export default LendingButton;
